import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { translateBatchFields } from "../translateBatch";

type DynamicFields = Record<string, string | undefined | null>;

function normalizeLanguage(language: string): string {
  return (language || "en").split("-")[0]?.toLowerCase() || "en";
}

export function useTranslateDynamicFields(
  fields: DynamicFields,
  language: string
) {
  const targetLanguage = normalizeLanguage(language);
  const TRANSLATION_CACHE_VERSION = "v2";

  const sanitizedFields = useMemo(() => {
    const entries = Object.entries(fields).filter(
      ([key, value]) => !!key && typeof value === "string" && value.trim().length > 0
    );
    return Object.fromEntries(entries.map(([key, value]) => [key, value!.trim()]));
  }, [fields]);

  return useQuery({
    queryKey: [
      "dynamic-translation",
      TRANSLATION_CACHE_VERSION,
      targetLanguage,
      sanitizedFields,
    ],
    enabled: targetLanguage !== "en" && Object.keys(sanitizedFields).length > 0,
    staleTime: 1000 * 60 * 30,
    queryFn: () => translateBatchFields(sanitizedFields, "en", targetLanguage),
  });
}
